<template>
  <div>
    <qrcode-stream @decode="onDecode" @init="onInit"/>
    <div class="optional-input-wrapper" v-if="optionalInput">
      <div class="f-16 f-bold">Anda bisa juga</div>
      <div class="optional-input-button">
        <SOButton
            text="Input Manual"
            :outline="true"
            :full="true"
            :edit="true"
            @action="() => {modalInput = true}"
        />
        <SOButton
            text="Dari Galeri"
            :outline="true"
            :full="true"
            :galeri="true"
            @action="upload"
        />
      </div>
      <qrcode-capture id="upload" @decode="onDecode"/>
    </div>
    <SOModalInputManual
        v-if="modalInput"
        @close="close"
        @input="(v) => {result = v}"
        @action="decodeManual"
    />
  </div>

</template>

<script>
import {QrcodeStream, QrcodeCapture} from "vue-qrcode-reader"
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOModalInputManual from "@/so-components/global/modal/SOModalInputManual";

export default {
  name: "SOInputScan",
  components: {
    SOModalInputManual,
    SOInputRegular,
    SOButton,
    SOSlotModal,
    SOSlotBase,
    SOTitleBar,
    QrcodeStream,
    QrcodeCapture
  },
  props: {
    optionalInput: Boolean
  },
  data() {
    return {
      result: "",
      modalInput: false
    }
  },
  methods: {
    async onInit(promise) {
      this.loading = true

      try {
        await promise
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    upload() {
      $('#upload').click();
    },

    close() {
      $("#modal-manual-input").modal("hide");
      this.modalInput = false
    },

    onDecode(result) {
      this.$emit('decode', result)
    },

    async decodeManual() {
      await this.close()
      this.$emit('decode', this.result)
    }
  },
}
</script>

<style scoped>
input[type=file] {
  width: 1px;
  visibility: hidden;
  display: none;
}

.qrcode-stream-wrapper {
  width: 100%;
  position: relative;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.optional-input-wrapper {
  padding: 16px 20px 24px;
  width: 100%;
  max-width: 480px;
  left: 50%;
  transform: translateX(-50%);

  position: absolute;
  z-index: 3;
  bottom: 0;

  background: #FFFFFF;
}

.optional-input-button {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 8px;
}

@media screen and (min-width: 800px) {
  .qrcode-stream-wrapper {
    max-width: 62vw;
  }
}

</style>